import React from "react";
import { Dropdown } from "antd";

import { useDispatch, useSelector } from "react-redux";
import { downloadRequest } from "../../store/actions/asset";


const AssetProfileDropdown = () => {
  const { filters } =
      useSelector((state) => ({
        filters: state.asset.filters,
      }));
  const dispatch = useDispatch();

  const handleExport = () => {
    dispatch(downloadRequest("assetList", filters));
  };

  
  const items = [
    {
      label: <span className="font-face-vzw">Actions</span>,
      key: `device-profile-actions`,
    },
    {
      label: (
        <button onClick={() => handleExport()} className="ats-text-btn">
          Export
        </button>
      ),
      key: `device-profile-export`,
    }
  ];

  return (
      <Dropdown
        key={`dropdown-device-profile-all`}
        menu={{
          items,
        }}
        trigger={["click"]}
        overlayClassName="shipment-dropdown-overlay"
      >
        <button className="btn btn-link text-secondary">
          <i className="bi-three-dots-vertical fs-6" />
        </button>
      </Dropdown>
  );
};

export default AssetProfileDropdown;